import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CurrencyContext = createContext(null);
const KEY = "ae_currency_v1";

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try {
      const saved = localStorage.getItem(KEY);
      if (saved === "INR" || saved === "USD") return saved;
    } catch {}
    // default to INR (primary). Could be region-detected later.
    return "INR";
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, currency); } catch {}
  }, [currency]);

  const setCurrency = useCallback((c) => {
    if (c === "INR" || c === "USD") setCurrencyState(c);
  }, []);

  const symbol = currency === "INR" ? "₹" : "$";

  const format = useCallback((product, qty = 1) => {
    if (!product) return "";
    const price = currency === "INR" ? product.price_inr : product.price_usd;
    const total = price * qty;
    if (currency === "INR") {
      return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(total);
    }
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(total);
  }, [currency]);

  const formatAmount = useCallback((amount) => {
    if (currency === "INR") {
      return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(amount);
    }
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(amount);
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, symbol, format, formatAmount }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
